import {AuwBaseComponent} from "EXT/auw_config/Resources/Private/Js/AuwBaseComponent";
import {AuwMasonry} from "EXT/auw_pages_meta/Resources/Private/Js/AuwMasonry";
import {AuwAjaxFilter} from "EXT/auw_pages_meta/Resources/Private/Js/AuwAjaxFilter";

export class AuwAjaxPager extends AuwBaseComponent{

    constructor($el){
        super($el);

        this.config = {

        }

    }

    init(){
        this.targetPageCollector = $('#'+this.config.targetPageCollector);
        this.$el = this.targetPageCollector.find('.ajax-pager');
        this.pagerLinks = this.$el.find('.pagination__item a');
        this.filterContainer = this.targetPageCollector.find(".ajax-filter");
        this.isRequesting = false;

    }


    __PageReady(){
        this.init();
        this.bindEvents();
    }

    bindEvents(){
        if(this.pagerLinks){
            this.pagerLinks.on("click",this.pagerItemClicked.bind(this));
        }
    }

    pagerItemClicked(e){
        e.preventDefault();
        if(!this.isRequesting) {
            this.isRequesting = true;
            var clickedElement = $(e.currentTarget);
            clickedElement.html("<i class='fas fa-spinner fa-spin'></i>");



            var arg = {};
            arg.requestParameter = {ajaxPage:clickedElement.data('ajaxPage'),ajaxCid:this.config.targetCid};

            //check if active filters are present
            if(this.filterContainer.length){
                arg.requestParameter.ajaxFilterTags = JSON.stringify(this.filterContainer.data('filterTags'));
                arg.requestParameter.ajaxFilterPageTypes = JSON.stringify(this.filterContainer.data('filterPageTypes'));
            }


            this.ajaxRequest = $.ajax({
                type:"GET",
                url:this.config.ajaxUri,
                data:arg,
            })
            .done(this.parseAnswer.bind(this))
            .fail( console.error)
            .always( this.requestFinished.bind(this));
        }
    }

    requestFinished(){
        this.isRequesting = false;
    }

    parseAnswer(data){
        this.targetPageCollector.replaceWith(data);
        this.init();
        this.bindEvents();
        //scrollen zu
        ScrollManager.scrollTo(this.targetPageCollector);
        //wenn es mit masonry war
        var elementWithMasonry = this.targetPageCollector.find('.with-masonry');
        if(elementWithMasonry.length){
            new AuwMasonry(elementWithMasonry);
        }

        //wenn es filter gibt
        if(this.filterContainer){
            this.filterContainer = this.targetPageCollector.find(".ajax-filter");
            new AuwAjaxFilter(this.filterContainer);
        }

    }

}